angular.module('FmsApp').factory("FieldPlotGeoFormatResource", function ($resource) {
   return $resource('/api/fms/fieldcrop/geo/:slug', {slug:'@plot_slug'});
});